module.exports = __webpack_public_path__ + "static/media/icon_delete_warning.a6b163ea.svg";